import React from "react";
import { FormSections } from "../formContent/formSections/FormSections";
import "./formSidebar.scss";

interface FormSidebarProps {
	isInAppSwitcher?: boolean;
}

export const FormSidebar: React.FC<FormSidebarProps> = ({ isInAppSwitcher = false }) => {
	return (
		<div className={`formSidebar ${isInAppSwitcher ? "in-app-switcher" : ""}`}>
			<FormSections />
		</div>
	);
};
